import firstIcon from '../asset/featureIcon-1.svg'
import secondIcon from '../asset/featureIcon-2.svg'
import thirdIcon from '../asset/featureIcon-3.svg'

export const startPageFeatureData = [
  {
    icon: firstIcon,
    title: 'Minimise admin and save time',
    text: (
      <p>
        Skip the paperwork and admin with CompareBanks and receive accurate
        product comparisons in less time.
      </p>
    ),
  },
  {
    icon: secondIcon,
    title: 'Bespoke products for you',
    text: (
      <p>
        CompareBanks links your banking data to recommend you the best product
        deals.
      </p>
    ),
  },
  {
    icon: thirdIcon,
    title: 'Easy set up',
    text: (
      <p>
        CompareBanks is approved by the Australian Government to collect and use
        data. The{' '}
        <a
          href="https://www.cdr.gov.au/"
          target="_blank"
          rel="noreferrer"
          title="CDR offical site"
          aria-label="CDR offical site"
        >
          Consumer Data Right
        </a>{' '}
        allows us to securely connect your accounts and data in just a few
        steps.
      </p>
    ),
  },
]
